<template>
  <v-row justify="center">

    <!-- In -->
    <v-col cols="12" sm="8" md="4">
      <v-card>
        <v-toolbar dense flat dark :color="toolbarColor" rounded>
          <v-toolbar-title :class="headingClass">
            {{ messagesReceivedFrom }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card :loading="isLoading">
          <template v-slot:progress>
            <v-progress-linear
              indeterminate
              :color="appColor_Progress"
            ></v-progress-linear>
          </template>

          <v-list-item two-line
            :align="'left'">
            <v-list-item-content>
              <v-list-item-subtitle v-html="timePeriodLabel" />
            </v-list-item-content>
          </v-list-item>
          
          <!-- summary table -->
          <!-- <v-card-text>
            <v-row>
              <v-col v-for="item in messagesIn" :key="item.title" cols="3">
                <v-chip
                  small
                  dark
                  :color="`${toolbarColor} lighten-2`"
                  class="mr-2"
                  >
                  {{ getExpression('Label', item.title) }}
                </v-chip>

                <span :class="labelClass">
                  {{ getSummaryListItemValue(item) }}
                </span>
              </v-col>
            </v-row>
          </v-card-text> -->

          <v-card-text>
            <template v-if="!hasMessagesIn">
              <span v-html="noMessagesInMessage"></span>
            </template>

            <!-- chart -->
            <template v-else>
              <doughnut-chart :chart-data="userToResidentChartData" />
            </template>
          </v-card-text>

        </v-card>
      </v-card>
    </v-col>

    <!-- In By type -->
    <v-col cols="12" sm="8" md="4">
    <v-card>
      <v-toolbar dense flat dark :color="toolbarColor" rounded>
        <v-toolbar-title :class="headingClass">
          {{ messagesReceivedByType }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card :loading="isLoading">
        <template v-slot:progress>
          <v-progress-linear
            indeterminate
            :color="appColor_Progress"
          ></v-progress-linear>
        </template>

        <v-list-item two-line
          :align="'left'" >
          <v-list-item-content>
            <v-list-item-subtitle v-html="timePeriodLabel" />
          </v-list-item-content>
        </v-list-item>
        
        <v-card-text>
          <template v-if="!hasMessagesIn">
            <span v-html="noMessagesInMessage"></span>
          </template>

          <!-- chart -->
          <template v-else>
            <doughnut-chart :chart-data="messageContentTypeChartData" />
          </template>
        </v-card-text>
      </v-card>
    </v-card>
    </v-col>

    <!-- Out -->
    <v-col cols="12" sm="8" md="4">
      <v-card>
        <v-toolbar dense flat dark :color="toolbarColor" rounded>
          <v-toolbar-title :class="headingClass">
            {{ messagesSentTo }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card :loading="isLoading">
          <template v-slot:progress>
            <v-progress-linear
              indeterminate
              :color="appColor_Progress"
            ></v-progress-linear>
          </template>

          <v-list-item two-line
            :align="'left'" >
            <v-list-item-content>
              <v-list-item-subtitle v-html="timePeriodLabel" />
            </v-list-item-content>
          </v-list-item>
          
          <!-- summary table -->
          <!-- <v-card-text>
            <v-row>
              <v-col v-for="item in messagesOut" :key="item.title" cols="3">
                <v-chip
                  small
                  dark
                  :color="`${toolbarColor} lighten-2`"
                  class="mr-2"
                  >
                  {{ getExpression('Label', item.title) }}
                </v-chip>

                <span :class="labelClass">
                  {{ getSummaryListItemValue(item) }}
                </span>
              </v-col>
            </v-row>
          </v-card-text> -->

          <v-card-text>
            <template v-if="!hasMessagesOut">
              <span v-html="noMessagesOutMessage"></span>
            </template>
  
            <!-- chart -->
            <template v-else>
              <doughnut-chart :chart-data="residentToUserChartData" />
            </template>
          </v-card-text>
        </v-card>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import appService from '@/app.service.js'
import { mapGetters } from 'vuex'
import { AppColor, DashboardClass } from '@/config.js'
import { DoughnutChart } from '@/charts/doughnutChart.js'

export default {
  name: 'MessagesChart',
  components: {
    DoughnutChart
  },
  props: {
    selectedTimePeriodValue: {
      type: String,
      default: 'WeekToDate'
    },
    trigger: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array,
      default: null
    },
    toolbarColor: {
      type: String,
      default: AppColor.Light
    }
  },
  data() {
    return { 
      // colors
      appColor_Progress: AppColor.Progress,
      appColor_Selected: AppColor.Selected,

      // styles
      headingClass: DashboardClass.Heading,
      labelClass: DashboardClass.Label,
      valueClass: DashboardClass.Value,

      // summary and chart data
      fromDate: null,
      toDate: null,
      userToResidentChartData: null,
      messagesIn: [],
      hasMessagesIn: false,
      residentToUserChartData: null,
      messagesOut: [],
      hasMessagesOut: false,
      messageContentTypeChartData: null,

      isLoading: true
    }
  },
  computed: {
    ...mapGetters(['activeResident', 'locale']),
    noMessagesInMessage () {
      if (this.isNullOrUndefined(this.messagesIn) || this.timePeriodLabel.length === 0) return ''
      return this.getExpression('Alert', 'NoMessagesIn').replace('{0}', this.activeResident.firstName)
    },
    noMessagesOutMessage () {
      if (this.isNullOrUndefined(this.messagesOut) || this.timePeriodLabel.length === 0) return ''
      return this.getExpression('Alert', 'NoMessagesOut').replace('{0}', this.activeResident.firstName)
    },
    timePeriodLabel () {
      if (this.isNullOrUndefined(this.fromDate) || this.isNullOrUndefined(this.toDate)) return ''

      return `<b>${this.getExpression('Label', 'From')}</b>
        ${this.$moment(this.fromDate).format('dddd MMMM D, YYYY')}</br>
        <b>${this.getExpression('Label', 'To')}</b>
        ${this.$moment(this.toDate).format('dddd MMMM D, YYYY')}`
    },
    messagesReceivedFrom () {
      return this.getExpression('FormTitle', 'MessagesReceivedFrom').replace('{0}', this.activeResident.firstName)
    },
    messagesReceivedByType () {
      return this.getExpression('FormTitle', 'MessagesReceivedByType').replace('{0}', this.activeResident.firstName)
    },
    messagesSentTo () {
      return this.getExpression('FormTitle', 'MessagesSentTo').replace('{0}', this.activeResident.firstName)
    }
  },
  methods: {
    loadData () {
      const self = this

      self.isLoading = true
      appService.getResidentDashboardMessagesChartData(self.activeResident.id, self.selectedTimePeriodValue, self.locale).then(data => {
        self.isLoading = false
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.fromDate = data.fromDate
          self.toDate = data.toDate
          self.userToResidentChartData = data.userToResidentChartData
          self.residentToUserChartData = data.residentToUserChartData
          self.messagesIn = data.messagesIn
          self.setHasMessagesIn(data.messagesIn)
          self.messagesOut = data.messagesOut
          self.setHasMessagesOut(data.messagesOut)
          self.messageContentTypeChartData = data.messageContentTypeChartData
          self.$emit('data-loaded')
        }
      }).catch(e => { self.handleCriticalError(e) })
    },

    getSummaryListItemValue (item) {
      if (item.type == 'DateTime')
        return this.$moment(item.value).format('MMM DD')
      return item.value
    },

    setHasMessagesIn(data) {
      this.hasMessagesIn = (data[0].value !== "0" || data[1].value !== "0")
    },

    setHasMessagesOut(data) {
      this.hasMessagesOut = (data[0].value !== "0" || data[1].value !== "0")
    },

    handleError (result) {
      this.$error.show({
        text: result.errorMessage,
        severity: result.errorSeverity,
        languageId: this.languageId
      })
    }
  },
  watch: {
    trigger (val) {
      if (val === null) return
      if (val) this.loadData()
    }
  }
}
</script>
